var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_setup.isMobile
    ? _c(_setup.InfoLayout, {
        attrs: {
          "current-path": _setup.reverseFull({ name: "legal_case" }),
          "is-policy": false,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "title",
              fn: function () {
                return [
                  _vm._v(
                    "\n    " +
                      _vm._s(_setup.t("Битва за отзывы", _setup.options)) +
                      "\n  "
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "content",
              fn: function () {
                return [
                  _c(
                    "div",
                    [
                      _c(_setup.AdminButton, {
                        attrs: {
                          text: _setup.t(
                            "Добавить судебное дело",
                            _setup.options
                          ),
                          link: _setup.reverseFull({
                            name: "admin:info_legalcase_add",
                          }),
                        },
                      }),
                      _vm._v(" "),
                      _c(_setup.LegalCaseBanner, {
                        attrs: {
                          "completed-cases": _setup.context.completed_cases,
                          "courthearing-count":
                            _setup.context.courthearing_count,
                          "during-cases": _setup.context.during_cases,
                          "won-cases": _setup.context.won_cases,
                          "is-mobile": _setup.isMobile,
                        },
                      }),
                      _vm._v(" "),
                      _vm._l(
                        _setup.context.legal_cases.__items__,
                        function (legalCase) {
                          return _c(_setup.LegalCaseCard, {
                            key: legalCase.id,
                            class: { "mb-4": !_setup.isMobile },
                            attrs: {
                              id: legalCase.id,
                              "legal-case": legalCase,
                            },
                          })
                        }
                      ),
                      _vm._v(" "),
                      _setup.pageRange.length > 1
                        ? _c(_setup.PagePagination, {
                            attrs: {
                              "data-qa": "legal_case_pagination",
                              mobile: _setup.context.flavour !== "full",
                              "pages-length": 2,
                              "current-page": _setup.context.page_num,
                            },
                            on: { input: _setup.handleInput },
                          })
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          2935655486
        ),
      })
    : _c(
        "div",
        [
          _c(_setup.AdminButton, {
            attrs: {
              text: _setup.t("Добавить судебное дело", _setup.options),
              link: _setup.reverseFull({ name: "admin:info_legalcase_add" }),
            },
          }),
          _vm._v(" "),
          _c(_setup.LegalCaseBanner, {
            attrs: {
              "completed-cases": _setup.context.completed_cases,
              "courthearing-count": _setup.context.courthearing_count,
              "during-cases": _setup.context.during_cases,
              "won-cases": _setup.context.won_cases,
              "is-mobile": _setup.isMobile,
            },
          }),
          _vm._v(" "),
          _vm._l(_setup.context.legal_cases.__items__, function (legalCase) {
            return _c(_setup.LegalCaseCard, {
              key: legalCase.id,
              class: { "mb-4": !_setup.isMobile },
              attrs: { id: legalCase.id, "legal-case": legalCase },
            })
          }),
          _vm._v(" "),
          _setup.pageRange.length > 1
            ? _c(_setup.PagePagination, {
                attrs: {
                  "data-qa": "legal_case_pagination",
                  mobile: _setup.context.flavour !== "full",
                  "pages-length": 2,
                  "current-page": _setup.context.page_num,
                },
                on: { input: _setup.handleInput },
              })
            : _vm._e(),
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }